<template>
  <div >
    <!-- <Navbar />
    <Sidebar /> -->
    <section
      class="main"
    >
      <DressListing
        @click="dressId"
      />
      <ColorListing
        :material-id="dressIdShow"
        :create-order="true"
        @click="colorId"
      />
      <ProductsTable
        :material-id="dressIdShow"
        :color-id="colorIdShow"
        :create-order="true"
        @addArticleItem="addArticleItem"
        @inside="inside"
      />
      <InsideProduct
        :added-article="addedArticle"
        :product-mat-obj="productMatObj"
        :create-order="true"
      />
    </section>

  </div>

</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebars/Sidebar.vue'
import Navbar from '@/components/Navbar.vue'
import DressListing from '@/components/products/DressListing.vue'
import ColorListing from '@/components/products/ColorListing.vue'
import ProductsTable from '@/components/products/ProductsTable.vue'
import InsideProduct from '@/components/products/InsideProduct.vue'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Sidebar,
    // eslint-disable-next-line vue/no-unused-components
    Navbar,
    DressListing,
    ColorListing,
    ProductsTable,
    InsideProduct,
  },
  data() {
    return {
      dressIdShow: '',
      colorIdShow: '',
      productMatObj: {},
      addedArticle: [],
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),
  },
  watch: {
    // eslint-disable-next-line func-names
    inside(item) {
      this.productMatObj = item
    },
  },
  methods: {
    addArticleItem(item) {
      this.addedArticle.push(item)
    },
    inside(item) {
      this.productMatObj = item
    },
    dressId(id) {
      this.dressIdShow = id
    },
    colorId(id) {
      this.colorIdShow = id
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  padding: 75px 15px 15px 120px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
@media screen and (max-width: 1600px) {
  .main{
    padding: 70px 20px 15px 95px;
  }
}

@media screen and (max-width: 1500px) {
  .flex{
   width: 40% !important;
  }
  .main{
    padding: 70px 20px 15px 80px;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
@media screen and (max-width: 1340px){
  .main{
    padding: 70px 15px 15px 95px;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
@media screen and (max-width: 1190px) {
  .main {
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 75px 15px 15px 10px;
  }
}

@media screen and (max-width: 896px) {
  .main {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
</style>
